<app-time-schedule-slot-edit
  class="full"
  [slot]="copy"
  (close)="onClose($event)"
  (save)="onSave($event)"
  (delete)="onDelete($event)"
>
</app-time-schedule-slot-edit>
